import { isString } from "lodash";
import { IFilters } from "@common/redux/slices/entities.slice";
import { ICheckboxSelectOption } from "@kursk/components/ui/CheckboxSelect/CheckboxSelect";

type TOptions = {
  items?: ICheckboxSelectOption[];
  filterField?: string;
}

export const getSellersAndSubjectsValues = (filters: IFilters, options: TOptions) => {
  if (options) {
    if (isString(filters[options.filterField])) {
      return filters[options.filterField].split(',')
    } else {
      return filters[options.filterField]
    }
  } else {
    return [];
  }

}
